import { CButton, Spinner } from "components";
import { OVOU_MAIN_SITE_URL } from "../../constants";
import { memo, useMemo } from "react";
import { INVITE_USER_MODAL_TEXTS } from "constants/Texts";

export type TCTAButtonProps =
  | TInviteButtonProps
  | TIncreaseSeatsButtonProps
  | TAddMoreCardsButtonProps;

type TBaseCTAButtonProps = {
  isLoading: boolean;
  isDisabled: boolean;
};

type TInviteButtonProps = TBaseCTAButtonProps & {
  type: "invite";
};

type TIncreaseSeatsButtonProps = TBaseCTAButtonProps & {
  type: "increase-seats";
};

type TAddMoreCardsButtonProps = TBaseCTAButtonProps & {
  type: "add-more-cards";
  teamId: number;
};

const BUTTON_TEXT = {
  invite: INVITE_USER_MODAL_TEXTS.INVITE_USER_BTN,
  "add-more-cards": INVITE_USER_MODAL_TEXTS.NO_AVAILABLE_CARDS_BTN,
  "increase-seats": INVITE_USER_MODAL_TEXTS.NO_AVAILABLE_SEAT_BTN,
};

export const CTAButton = memo(function CTAButton(props: TCTAButtonProps) {
  const { type, isLoading, isDisabled } = props;
  const teamId = "teamId" in props ? props.teamId : undefined;

  const buttonRestProps = useMemo(() => {
    switch (type) {
      case "invite":
      case "increase-seats":
        return {
          type: "submit" as const,
        };

      case "add-more-cards": {
        return {
          as: "a" as const,
          href: `${OVOU_MAIN_SITE_URL}/checkout/?add-to-cart=7146&team_id=${teamId}`,
          target: "_blank",
        };
      }
    }
  }, [type, teamId]);

  return (
    <CButton
      width="100%"
      height="56px"
      isDisabled={isDisabled}
      _focus={{ outline: "none" }}
      marginTop="24px"
      {...buttonRestProps}
    >
      {isLoading ? <Spinner color="white" /> : BUTTON_TEXT[type]}
    </CButton>
  );
});
